module.exports = __webpack_public_path__ + "img/icon-listing.027f726a.svg";